import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/team", label: "Team" },
  { to: "/branches", label: "Branches" },
  { to: "/portal", label: "Capability Building" },
  { to: "/contact", label: "Contact" },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-white/95 border-b border-[#E5E5E5]"
          : "bg-white border-b border-transparent"
      }`}
    >
      <div className="container-pro flex items-center justify-between h-24">
        <Link
          to="/"
          data-testid="logo-link"
          className="flex items-center group"
          aria-label="Anila Consulting — Home"
        >
          <img
            src="/anila-logo.png"
            alt="Anila Consulting"
            className="h-16 md:h-20 w-auto object-contain block transition-transform duration-300 group-hover:scale-[1.03]"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `link-underline text-sm tracking-wider uppercase font-medium ${
                  isActive ? "active" : ""
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/contact"
          data-testid="header-cta-button"
          className="hidden md:inline-flex btn-primary"
        >
          Book Our Time
        </Link>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-[#111111]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden border-t border-[#E5E5E5] bg-white"
        >
          <div className="container-pro py-6 flex flex-col gap-4">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`mobile-nav-link-${item.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-base uppercase tracking-wider font-medium py-2 ${
                    isActive ? "text-[#8B0000]" : "text-[#111111]"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              data-testid="mobile-cta-button"
              className="btn-primary w-full justify-center mt-2"
            >
              Book Our Time
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
